import { render, staticRenderFns } from "./FlowMyBusinessList.vue?vue&type=template&id=12fa5fbf&scoped=true"
import script from "./FlowMyBusinessList.vue?vue&type=script&lang=js"
export * from "./FlowMyBusinessList.vue?vue&type=script&lang=js"
import style0 from "./FlowMyBusinessList.vue?vue&type=style&index=0&id=12fa5fbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa5fbf",
  null
  
)

export default component.exports